import React from 'react';

export default {
  'cardBuilder.removeCard': <i className="ion-ios-close-circle"/>,
  'cardBuilder.editCard': <i className="ion-md-create"/>,
  'cardBuilder.addCard': <i className="ion-ios-add" />,
};
